import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// Inverse of RequireAuth: redirect signed-in users away from pages that
// only make sense for guests (/login, /register). Honours ``?next=`` if
// the login flow stashed a return-to target.
export default function RequireGuest({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg text-secondText text-sm">
        Loading…
      </div>
    );
  }

  if (status === "signedIn") {
    const params = new URLSearchParams(location.search);
    const next = params.get("next");
    const target = next && next.startsWith("/") ? next : "/";
    return <Navigate to={target} replace />;
  }

  return children;
}
